export enum showCountryFilterStates {
  ShowComplete = 1,
  ShowByRegion,
  Hide,
}
